import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"

import { getLedger } from "src/api/Billing/Ledgers"

import BalanceCard from "./BalanceCard"

const ContactBalances = ({ initialLedgerData }) => {
  const { marinaSlug, presentmentCurrency } = useMarina()

  const { data: ledgerData } = useQuery(
    ["ledger", marinaSlug, initialLedgerData.id],
    () => getLedger({ marinaSlug, ledgerId: initialLedgerData.id }),
    {
      initialData: initialLedgerData,
      refetchOnMount: false,
    }
  )

  return (
    <div
      data-testid="contact-balances"
      className="flex flex-col space-y-4 md:flex-row md:space-x-4 md:space-y-0"
    >
      <BalanceCard
        title="Overdue"
        icon="fa-clock-far"
        amountInCents={ledgerData.overdueBalance}
        description="Non-settled invoices due in the past"
        variant="red"
        currency={presentmentCurrency}
      />
      <BalanceCard
        title="Total Balance"
        icon="fa-cash"
        amountInCents={ledgerData.totalBalance}
        description="All non-settled invoices (including future)"
        currency={presentmentCurrency}
      />
      <BalanceCard
        title="Total Spent"
        icon="fa-cash-multiple"
        amountInCents={ledgerData.totalSpent}
        description="All payments made (all time)"
        currency={presentmentCurrency}
      />
    </div>
  )
}

export const initialLedgerDataProps = {
  id: PropTypes.string.isRequired,
  totalBalance: PropTypes.number.isRequired,
  overdueBalance: PropTypes.number.isRequired,
  totalSpent: PropTypes.number.isRequired,
}

ContactBalances.propTypes = {
  initialLedgerData: PropTypes.shape(initialLedgerDataProps).isRequired,
}

export default ContactBalances
